exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2B_D-{display:block;width:24px;height:24px;margin-right:10px;margin-bottom:10px;border-radius:12px;margin-top:3px;position:relative;cursor:pointer}._3ARa9{position:absolute;display:none;top:-30px;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;background-color:rgba(0,0,0,.85);font-size:11px;color:#fff;padding:1px 3px 2px;z-index:82}._2B_D-:hover ._3ARa9{-webkit-transition-delay:.5s;-o-transition-delay:.5s;transition-delay:.5s;display:block;top:-10px}._2i5Ea{border:3px solid #fff}._2i5Ea:before{left:0;top:0;bottom:0;border-radius:12px;right:0;z-index:2;background-color:hsla(0,0%,100%,.8)}._2i5Ea:after,._2i5Ea:before{content:\" \";position:absolute}._2i5Ea:after{left:5px;top:5px;z-index:3;width:10px;height:6px;border-bottom:2px solid #000;border-left:2px solid #000;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}", ""]);

// exports
exports.locals = {
	"root": "_2B_D-",
	"popover": "_3ARa9",
	"active": "_2i5Ea"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/SearchPanel/ColorItem/ColorItem.css
// module id = 1986
// module chunks = 0 1 15 17